// extracted by mini-css-extract-plugin
export default {"empty":"Report_empty__G3dWQ","placeHolderShimmer":"Report_placeHolderShimmer__yQgNZ"};